import { render } from "./AgentDashboard.vue?vue&type=template&id=8ffae220&scoped=true&ts=true"
import script from "./AgentDashboard.vue?vue&type=script&lang=ts"
export * from "./AgentDashboard.vue?vue&type=script&lang=ts"

import "./AgentDashboard.vue?vue&type=style&index=0&id=8ffae220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ffae220"]])

export default __exports__